import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export interface SocialCardVerifyResponse {
  event_name: string;
  event_date: string;
  event_venue: string;
  attendee_name: string;
  company?: string;
  role?: string;
}

export interface TextTemplate {
  value: string;
  label: string;
}

export interface SocialCardTemplatesResponse {
  templates: TextTemplate[];
}

export interface SocialCardGenerateRequest {
  ticket_code: string;
  image_data: string;
  company_logo?: string;
  text_template: string;
  custom_text?: string;
  include_name?: boolean;
  include_company?: boolean;
  include_role?: boolean;
}

export interface SocialCardGenerateResponse {
  card_image: string;
  download_url?: string;
}

class SocialCardsApi {
  private getHeaders() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async verifyTicket(ticketCode: string): Promise<SocialCardVerifyResponse> {
    const response = await axios.get(
      `${API_BASE_URL}/social-cards/verify/${ticketCode}`
    );
    return response.data;
  }

  async getTemplates(): Promise<SocialCardTemplatesResponse> {
    const response = await axios.get(
      `${API_BASE_URL}/social-cards/templates`
    );
    return response.data;
  }

  async generateCard(request: SocialCardGenerateRequest): Promise<SocialCardGenerateResponse> {
    const response = await axios.post(
      `${API_BASE_URL}/social-cards/generate`,
      request
    );
    return response.data;
  }

  async sendLink(registrationId: number): Promise<void> {
    await axios.post(
      `${API_BASE_URL}/social-cards/send-link`,
      { registration_id: registrationId },
      { headers: this.getHeaders() }
    );
  }

  async trackDownload(ticketCode: string): Promise<void> {
    try {
      await axios.post(
        `${API_BASE_URL}/social-cards/track-download`,
        { ticket_code: ticketCode }
      );
    } catch (error) {
      // Silently fail - this is just tracking
      console.log('Failed to track download:', error);
    }
  }
}

export const socialCardsApi = new SocialCardsApi();